import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { observable, action, makeObservable } from 'mobx'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { COURSE_COMMENTS_FORM_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'
import { desktopResolution } from 'constants/browser.constants'
import { ROOT_URL, ELOPAGE_PROFILE_CABINETS } from 'constants/general.constants'

import { trimEditorText } from 'utils/froala.utils'

import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { TextEditorField } from '@elo-kit/components/form/text-editor-field/TextEditorField'
import { EloAvatar } from '@elo-ui/components/elo-avatar'

import CustomButton from '../custom-button/CustomButton'

const propTypes = {
  addComment: PropTypes.func.isRequired,
  handleReply: PropTypes.func,
  commentId: PropTypes.number,
  isReply: PropTypes.bool,
  avatarUrl: PropTypes.string,
}

@observer
class CommentsForm extends Component {
  @observable commentValue = ''

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  @action handleCommentChange = (value) => (this.commentValue = value)

  @action handleCommentAdd = () => {
    const { addComment, commentId, handleReply, toggleCommentsArea } = this.props
    addComment(this.commentValue, commentId)
    handleReply && handleReply('')
    this.commentValue = ''
    toggleCommentsArea(false)
  }

  render() {
    const {
      avatarUrl,
      customView,
      handleReply,
      isReply,
      fontFamilyList,
      showCommentsArea,
      toggleCommentsArea,
      isPayerCabinet,
      commentUserName,
    } = this.props

    const commentsFormClasses = classNames('comments-form', COURSE_COMMENTS_FORM_CLASS_NAMES.containerClassName, {
      'reply-form': isReply,
    })

    const Button = (props) => (customView ? <CustomButton outline {...props} /> : <EloButton outlined {...props} />)

    const disabled = !trimEditorText(this.commentValue)

    const handleRedirectToProfile = () => {
      const cabinet = isPayerCabinet ? ELOPAGE_PROFILE_CABINETS.payer : ELOPAGE_PROFILE_CABINETS.seller

      window.open(`${ROOT_URL}/${cabinet}/profile/edit`, '_blank')
    }

    return (
      <div className={commentsFormClasses}>
        {desktopResolution ? (
          <Fragment>
            <div>
              <div className='comment-form' onClick={handleRedirectToProfile}>
                <EloAvatar shape='circle' size='large' src={avatarUrl} />
                <div>{commentUserName}</div>
              </div>
              <div className='comment-text-area'>
                <TextEditorField
                  name='comment'
                  value={this.commentValue}
                  onChange={this.handleCommentChange}
                  fontFamilyList={fontFamilyList}
                />
              </div>
            </div>
            <div className='text-right comment-buttons-container'>
              {isReply && (
                <EloButton grey outlined onClick={() => handleReply('')}>
                  {I18n.t('shared.common.cancel')}
                </EloButton>
              )}

              <Button disabled={disabled} onClick={this.handleCommentAdd}>
                <i className='fas fa-comment' />
                {I18n.t('react.shared.comments.send_comment')}
              </Button>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {!isReply && (
              <CustomButton className='fields-container--full-width' onClick={() => toggleCommentsArea(true)} outline>
                <i className='fas fa-comment' />
                {I18n.t('react.shared.button.add_comment')}
              </CustomButton>
            )}

            {(showCommentsArea || isReply) && (
              <div className='mobile-comment-form'>
                <i
                  className='fas fa-times-circle'
                  onClick={isReply ? () => handleReply('') : () => toggleCommentsArea(false)}
                />
                <div className='mobile-comment-container'>
                  <div className='round-image-36' style={{ backgroundImage: getBackgroundImageCss(avatarUrl) }} />
                  <div className='fields-container--full-width fields-container--without-margins'>
                    <TextEditorField
                      name='comment'
                      value={this.commentValue}
                      onChange={this.handleCommentChange}
                      fontFamilyList={fontFamilyList}
                      className='text-editor-field--wrapper-height-50'
                    />
                  </div>
                </div>
                <div className='mobile-post-button'>
                  <CustomButton onClick={this.handleCommentAdd} disabled={disabled}>
                    {I18n.t('react.shared.button.post_comment')}
                  </CustomButton>
                </div>
              </div>
            )}
          </Fragment>
        )}
      </div>
    )
  }
}

CommentsForm.displayName = 'CommentsForm'
CommentsForm.propTypes = propTypes

export default CommentsForm
